/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StartSubscriptionFlowResponse
 */
export interface StartSubscriptionFlowResponse {
    /**
     * 
     * @type {string}
     * @memberof StartSubscriptionFlowResponse
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StartSubscriptionFlowResponse
     */
    created: boolean;
}

/**
 * Check if a given object implements the StartSubscriptionFlowResponse interface.
 */
export function instanceOfStartSubscriptionFlowResponse(value: object): value is StartSubscriptionFlowResponse {
    if (!('created' in value) || value['created'] === undefined) return false;
    return true;
}

export function StartSubscriptionFlowResponseFromJSON(json: any): StartSubscriptionFlowResponse {
    return StartSubscriptionFlowResponseFromJSONTyped(json, false);
}

export function StartSubscriptionFlowResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartSubscriptionFlowResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'created': json['created'],
    };
}

export function StartSubscriptionFlowResponseToJSON(json: any): StartSubscriptionFlowResponse {
    return StartSubscriptionFlowResponseToJSONTyped(json, false);
}

export function StartSubscriptionFlowResponseToJSONTyped(value?: StartSubscriptionFlowResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'created': value['created'],
    };
}

